var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-sticky',[_c('van-nav-bar',{attrs:{"title":"工银生肖信用卡","left-arrow":""},on:{"click-left":_vm.onClickLeft}})],1),_c('img',{attrs:{"src":require("@/assets/images/animal.jpg")}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }